import React from 'react';

interface ContentTypeSelectorProps {
  contentType: 'markdown' | 'rich-text';
  onChange: (type: 'markdown' | 'rich-text') => void;
  disabled?: boolean;
}

const ContentTypeSelector: React.FC<ContentTypeSelectorProps> = ({
  contentType,
  onChange,
  disabled = false
}) => {
  return (
    <div className="mb-4 p-3 border border-gray-200 rounded-lg bg-gray-50">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Content Type
      </label>
      <div className="flex space-x-4">
        <label className="flex items-center">
          <input
            type="radio"
            name="contentType"
            value="markdown"
            checked={contentType === 'markdown'}
            onChange={(e) => onChange(e.target.value as 'markdown' | 'rich-text')}
            disabled={disabled}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">
            📝 Markdown
            <span className="text-xs text-gray-500 block">
              Simple text formatting with markdown syntax
            </span>
          </span>
        </label>
        
        <label className="flex items-center">
          <input
            type="radio"
            name="contentType"
            value="rich-text"
            checked={contentType === 'rich-text'}
            onChange={(e) => onChange(e.target.value as 'markdown' | 'rich-text')}
            disabled={disabled}
            className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">
            🎨 Rich Text
            <span className="text-xs text-gray-500 block">
              WYSIWYG editor with images, tables, and formatting
            </span>
          </span>
        </label>
      </div>
      
      {contentType === 'rich-text' && (
        <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded text-sm text-blue-700">
          💡 <strong>Rich text mode:</strong> You can drag & drop images, create tables, 
          add links, and use visual formatting. Images are automatically uploaded to your storage.
        </div>
      )}
      
      {contentType === 'markdown' && (
        <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded text-sm text-green-700">
          📋 <strong>Markdown mode:</strong> Use markdown syntax like **bold**, *italic*, 
          # headers, and [links](url). Use the image upload button for the featured image.
        </div>
      )}
    </div>
  );
};

export default ContentTypeSelector;